module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout_sharp_left.3a533644.png";